<script>
export default {
  props: {
    width: {
      type: [String, Number],
      default: '1.5rem',
    },
    height: {
      type: [String, Number],
      default: '1.5rem',
    },
    strokeWidth: {
      type: [String, Number],
      default: 2,
    },
    fillColor: {
      type: String,
      default: 'none',
    },
  },
}
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      class="stroke-royal-blue-100 fill-white"
      :stroke-width="strokeWidth"
    />
  </svg>
</template>
